module.exports = __webpack_public_path__ + "assets/img/3_1211.329d022f.jpg";